import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-14 pb-5 px-5" }
const _hoisted_2 = { class: "mt-4 flex flex-col md:flex-row gap-6 px-12 text-start" }
const _hoisted_3 = { class: "w-full md:w-1/3" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "w-full md:w-1/3" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "w-full md:w-1/3" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "mt-8 flex flex-col md:flex-row gap-6 px-12 text-start" }
const _hoisted_13 = { class: "w-full md:w-1/3" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "w-full md:w-1/3" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "w-full md:w-1/3" }
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "mt-8 flex flex-col md:flex-row gap-6 px-12 text-start" }
const _hoisted_23 = { class: "w-full md:w-1/3" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "w-full md:w-1/3" }
const _hoisted_27 = { class: "font-bold" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/3" }, null, -1)
const _hoisted_30 = { class: "mt-8 flex flex-col md:flex-row gap-6 px-12 text-start" }
const _hoisted_31 = { class: "flex items-center gap-1" }
const _hoisted_32 = { class: "mt-8 flex justify-end px-12 gap-x-6" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageTitle, { title: "settings.title" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('settings.preparing_max_delay_time')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settings.preparing_max_delay_time) = $event)),
          type: "number",
          placeholder: _ctx.$t('settings.preparing_max_delay_time'),
          class: "h-42 bg-white input px-2 w-full mt-2"
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.settings.preparing_max_delay_time]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('settings.ready_for_pick_up_max_delay_time')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settings.ready_for_pick_up_max_delay_time) = $event)),
          type: "number",
          placeholder: _ctx.$t('settings.ready_for_pick_up_max_delay_time'),
          class: "h-42 bg-white input px-2 w-full mt-2"
        }, null, 8, _hoisted_8), [
          [_vModelText, _ctx.settings.ready_for_pick_up_max_delay_time]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('settings.assigned_max_delay_time')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settings.assigned_max_delay_time) = $event)),
          type: "number",
          placeholder: _ctx.$t('settings.assigned_max_delay_time'),
          class: "h-42 bg-white input px-2 w-full mt-2"
        }, null, 8, _hoisted_11), [
          [_vModelText, _ctx.settings.assigned_max_delay_time]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('settings.picked_up_max_delay_time')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settings.picked_up_max_delay_time) = $event)),
          type: "number",
          placeholder: _ctx.$t('settings.picked_up_max_delay_time'),
          class: "h-42 bg-white input px-2 w-full mt-2"
        }, null, 8, _hoisted_15), [
          [_vModelText, _ctx.settings.picked_up_max_delay_time]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('settings.on_the_way_max_delay_time')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settings.on_the_way_max_delay_time) = $event)),
          type: "number",
          placeholder: _ctx.$t('settings.ready_for_pick_up_max_delay_time'),
          class: "h-42 bg-white input px-2 w-full mt-2"
        }, null, 8, _hoisted_18), [
          [_vModelText, _ctx.settings.on_the_way_max_delay_time]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('settings.at_the_address_max_delay_time')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settings.at_the_address_max_delay_time) = $event)),
          type: "number",
          placeholder: _ctx.$t('settings.at_the_address_max_delay_time'),
          class: "h-42 bg-white input px-2 w-full mt-2 mt-2"
        }, null, 8, _hoisted_21), [
          [_vModelText, _ctx.settings.at_the_address_max_delay_time]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('settings.to_return_max_delay_time')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settings.to_return_max_delay_time) = $event)),
          type: "number",
          placeholder: _ctx.$t('settings.to_return_max_delay_time'),
          class: "h-42 bg-white input px-2 w-full mt-2"
        }, null, 8, _hoisted_25), [
          [_vModelText, _ctx.settings.to_return_max_delay_time]
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('settings.on_the_way_max_delay_time')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settings.to_return_assigned_max_delay_time) = $event)),
          type: "number",
          placeholder: _ctx.$t('settings.to_return_assigned_max_delay_time'),
          class: "h-42 bg-white input px-2 w-full mt-2"
        }, null, 8, _hoisted_28), [
          [_vModelText, _ctx.settings.to_return_assigned_max_delay_time]
        ])
      ]),
      _hoisted_29
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _withDirectives(_createElementVNode("input", {
          name: "check_unpaid_orders_from_the_previous_day",
          id: "check_unpaid_orders_from_the_previous_day",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.settings.check_unpaid_orders_from_the_previous_day) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.settings.check_unpaid_orders_from_the_previous_day]
        ]),
        _createElementVNode("div", {
          role: "button",
          class: "font-bold",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.settings.check_unpaid_orders_from_the_previous_day = !_ctx.settings.check_unpaid_orders_from_the_previous_day))
        }, _toDisplayString(_ctx.$t('settings.check_unpaid_orders_from_the_previous_day')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("button", {
        class: "tertiary flex items-center px-5 py-3",
        disabled: _ctx.loading,
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.retryERPSync && _ctx.retryERPSync(...args)))
      }, _toDisplayString(_ctx.$t('buttons.retryErpsSync')), 9, _hoisted_33),
      _createElementVNode("button", {
        class: "primary flex items-center px-5 py-3",
        disabled: _ctx.loading,
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateSettings && _ctx.updateSettings(...args)))
      }, _toDisplayString(_ctx.$t('buttons.saveChanges')), 9, _hoisted_34)
    ])
  ]))
}